import { render } from "./UnfixedHeaderTable.vue?vue&type=template&id=66b609f8"
import script from "./UnfixedHeaderTable.vue?vue&type=script&lang=ts"
export * from "./UnfixedHeaderTable.vue?vue&type=script&lang=ts"
script.render = render

export default script